import {
  FERTILITY,
  MENOPAUSE,
  PREGNANCY_AND_POSTPARTUM,
} from '@progyny/utils/constants'

export type OnboardingResumeStepSpec = {
  productLine: string
  /** Me-query field paths (and related keys) evaluated for this resume step */
  serverData: readonly string[]
  parentRoute: string
  route: string
}

export const ONBOARDING_RESUME_STEP_MAP: readonly OnboardingResumeStepSpec[] = [
  {
    productLine: '*',
    serverData: [
      'member.acceptedPrivacyStatement',
      'member.acceptedTermsConditions',
    ],
    parentRoute: '/create-account',
    route: '/terms',
  },
  {
    productLine: '*',
    serverData: ['member.birthDate'],
    parentRoute: '/create-account',
    route: '/birth-date',
  },
  {
    productLine: '*',
    serverData: ['member.city'],
    parentRoute: '/create-account',
    route: '/city',
  },
  {
    productLine: '*',
    serverData: [],
    parentRoute: '/create-account',
    route: '/preferences',
  },
  {
    productLine: '*',
    serverData: ['member.availableProductLines', 'member.activeMemberJourney'],
    parentRoute: '/select-journey',
    route: '',
  },
  {
    productLine: '*',
    serverData: ['member.availableProductLines', 'member.activeMemberJourney'],
    parentRoute: '/create-account',
    route: '/complete',
  },
  {
    productLine: MENOPAUSE,
    serverData: ['member.menopauseJourney.menstrualPeriodStatus'],
    parentRoute: '/set-up-profile',
    route: '/menstrual-period',
  },
  {
    productLine: MENOPAUSE,
    serverData: ['member.menopauseJourney.lastMenstrualPeriod'],
    parentRoute: '/set-up-profile',
    route: '/last-menstrual',
  },
  {
    productLine: MENOPAUSE,
    serverData: ['member.menopauseJourney.menopauseSymptoms'],
    parentRoute: '/set-up-profile',
    route: '/menstrual-symptoms',
  },
  {
    productLine: PREGNANCY_AND_POSTPARTUM,
    serverData: ['member.pregnancyPostpartumJourney.pregnancyPostpartumStatus'],
    parentRoute: '/set-up-profile',
    route: '/pregnancy-info',
  },
  {
    productLine: PREGNANCY_AND_POSTPARTUM,
    serverData: [
      'member.pregnancyPostpartumJourney.dueDate',
      'member.pregnancyPostpartumJourney.deliveryDate',
    ],
    parentRoute: '/set-up-profile',
    route: '/pregnancy-date',
  },
  {
    productLine: FERTILITY,
    serverData: ['member.birthAssignedSex'],
    parentRoute: '/set-up-profile',
    route: '/birth-assigned-sex',
  },
  {
    productLine: FERTILITY,
    serverData: ['member.genderIdentity'],
    parentRoute: '/set-up-profile',
    route: '/gender-identity',
  },
  {
    productLine: FERTILITY,
    serverData: ['member.relationshipDynamic'],
    parentRoute: '/set-up-profile',
    route: '/relationship-dynamic',
  },
  {
    productLine: FERTILITY,
    serverData: ['member.familyFormingJourney'],
    parentRoute: '/set-up-profile',
    route: '/family-forming-journey',
  },
]
